export default {
  props: {
    recommendInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.showHandle();
    });
  },
  methods: {
    recommendTitle() {
      return this.getRecommendProperty('title');
    },
    handleClick() {
      const url = this.getRecommendProperty('action_url');
      this.$emit('searchClick', url);
    },
    getRecommendProperty(propertyName) {
      const {
        recommendInfo = {}
      } = this;
      const {
        recommend_list = []
      } = recommendInfo;
      return recommend_list.length > 0 && recommend_list[0][propertyName] || '';
    },
    showHandle() {
      // 监听对象
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // 如果目标元素进入视窗
          if (entry.intersectionRatio > 0) {
            const showElement = entry.target;
            // 展现埋点
            this.$emit('showSearchPV');
            // 曝光上报完成，取消观察该元素
            observer.unobserve(showElement);
          }
        });
      });
      const obDom = this.$refs.searchDom;
      observer.observe(obDom);
    }
  }
};